import moment from 'moment'

export default {
  name: 'YearMonthPicker',
  components: {
  },
  data () {
    const today = moment();
    return {
      month: today.format('M'),
      year: today.format('YYYY'),
      date: new Date()
    };
  },
  computed: {
    month_names () {
      return this.$t('general.datestr.ismonth');
    },
    year_list () {
      const years = [];

      for (let i = 2024; i < 2034; i++) {
        years.push(i);
      }

      return years;
    }
  },
  methods: {
    set_month: function (month) {
      this.date.setMonth(month);
      this.display();
    },
    select_month: function (event) {
      this.set_month(event.target.value - 1);
    },
    select_year: function (event) {
      this.date.setYear(event.target.value);
      this.display();
    },
    prev_month: function () {
      this.set_month(this.date.getMonth() - 1);
    },
    next_month: function () {
      this.set_month(this.date.getMonth() + 1);
    },
    display: function () {
      this.month = this.date.getMonth() + 1;
      this.year = this.date.getFullYear();

      if (!this.year_list.includes(this.year)) {
        if (this.year < this.year_list[0]) {
          this.year = this.year_list[this.year_list.length - 1];
        } else {
          this.year = this.year_list[0];
        }

        this.date.setYear(this.year);
      }

      this.$emit('filter', {
        month: this.month,
        year: this.year
      });
    }
  },
  mounted () {
    this.date.setMonth(this.month - 1);
    this.date.setYear(this.year);
    this.display();
  }
}
